// Starting a league's next season (PLAN-2026-10-27-the-next-season §2.1, §4):
// `POST /api/leagues/:id/next-season`, answered with the new season's league.

import { LeagueRef, type NextSeasonRequest } from '@fsp/domain';
import { send, type Reply } from './api';

export function startNextSeason(
  leagueId: string,
  body: NextSeasonRequest,
): Promise<Reply<LeagueRef>> {
  return send('POST', `/leagues/${encodeURIComponent(leagueId)}/next-season`, body, LeagueRef);
}
